export const contingentPlusIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 12"><path d="M6.19.81v10.38M1 6h10.38" stroke="#2D323A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'plus',
};
